export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_07-EN-823bc67ea3517a22253bfc11c7d1e6f0.webp";